import {
  UpdateDocumentsTemplateDocument,
  UpdateDocumentsTemplateMutation,
  UpdateDocumentsTemplateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateDocumentTemplate = () => {
  const [mutate, { loading }] = useMutation(UpdateDocumentsTemplateDocument, {
    extractorFn: (data: UpdateDocumentsTemplateMutation) =>
      data.documentsMutations.updateDocumentsTemplate,
  })

  const updateDocumentTemplate = (variables: UpdateDocumentsTemplateMutationVariables) => {
    return mutate({
      variables,
    })
  }

  return { updateDocumentTemplate, loading }
}
